<template>
  <v-text-field
    v-model="inputValue"
    v-bind="inputProps"
    outlined
    :class="inputProps.classList"
    @blur="$emit('blur', $event)"
  />
</template>
<script>
import { defineComponent, computed } from "vue";
// Decided server will handle formatting instead of frontend side
//import getObjectById from "@/utils/inputs/get_object_by_id";
//import appMask from "@/utils/inputs/app_mask";

export default defineComponent({
  name: "AppInputRegistryCode",
  props: {
    value: {
      type: String,
      default: ""
    },
    registryCountryId: {
      type: String,
      default: null
    },
    contactType: {
      type: String,
      default: null
    },
    inputProps: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props, ctx) {
    const inputValue = computed({
      get() {
        return props.value;
      },
      set(v) {
        ctx.emit("input", v);
        //ctx.emit("input", appMask(v, mask.value));
      }
    });

    /* const mask = computed(() => {
      const countryAlpha2 = getObjectById(props.registryCountryId, "Country")
        ?.alpha2;

      switch (props.contactType) {
        case "ORGANISATION":
          switch (countryAlpha2) {
            case "FI":
              return "#######-#";
            case "BE":
              return "####.###.###";
            default:
              return null; //"************************";
          }

        default:
          switch (countryAlpha2) {
            case "FI":
              return "######P###X";
            case "BE":
              return "##.##.## ###.##";
            default:
              return null; //"************************";
          }
      }
    });*/

    return {
      inputValue
    };
  }
});
</script>
